import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FaTimes, FaCheckCircle, FaExclamationTriangle, FaInfoCircle, FaExclamationCircle } from 'react-icons/fa';
import './Toast.css';

const Toast = ({ toast, message, type = 'success', onClose, duration = 5000 }) => {
    const resolvedShow = toast?.show ?? Boolean(message);
    const resolvedMessage = toast?.message ?? message;
    const resolvedType = toast?.type ?? type;

    useEffect(() => {
        if (resolvedShow && duration > 0) {
            const timer = setTimeout(onClose, duration);
            return () => clearTimeout(timer);
        }
    }, [resolvedShow, onClose, duration]);

    if (!resolvedShow || !resolvedMessage) {
        return null;
    }

    const getIcon = () => {
        switch (resolvedType) {
            case 'success':
                return <FaCheckCircle />;
            case 'error':
                return <FaExclamationCircle />;
            case 'warning':
                return <FaExclamationTriangle />;
            case 'info':
                return <FaInfoCircle />;
            default:
                return <FaInfoCircle />;
        }
    };

    const content = (
        <div className={`toast toast-${resolvedType}`}>
            {getIcon()}
            <span>{resolvedMessage}</span>
            <button type="button" className="toast-close" onClick={onClose}>
                <FaTimes />
            </button>
        </div>
    );

    return typeof document !== 'undefined'
        ? createPortal(content, document.body)
        : content;
};

export default Toast;